"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _enums = require("../../../enums");
var _MarkerEllipse = _interopRequireDefault(require("./MarkerEllipse"));
var _MarkerLine = _interopRequireDefault(require("./MarkerLine"));
var _MarkerPoint = _interopRequireDefault(require("./MarkerPoint"));
var _MarkerPolygon = _interopRequireDefault(require("./MarkerPolygon"));
var _MarkerRectangle = _interopRequireDefault(require("./MarkerRectangle"));
var _Group = require("../Group");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type"]; // enums
// components
// transform group
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function KonvaMarker(_ref) {
  var type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  switch (type) {
    case "Ellipses":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerEllipse.default, _objectSpread({}, props));
    case "Lines":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerLine.default, _objectSpread({}, props));
    case "Points":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerPoint.default, _objectSpread({}, props));
    case "Polygons":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerPolygon.default, _objectSpread({}, props));
    case "Rectangles":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerRectangle.default, _objectSpread({}, props));
    default:
      return null;
  }
}
function Marker(_ref2) {
  var id = _ref2.id,
    type = _ref2.type,
    data = _ref2.data,
    rotation = _ref2.rotation,
    formatDisplayTemperature = _ref2.formatDisplayTemperature,
    _ref2$isSelected = _ref2.isSelected,
    isSelected = _ref2$isSelected === void 0 ? true : _ref2$isSelected,
    onMouseDown = _ref2.onMouseDown,
    _onMouseEnter = _ref2.onMouseEnter,
    onMarkerUpdate = _ref2.onMarkerUpdate;
  var _useState = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    lastTransform = _useState2[0],
    setLastTransform = _useState2[1];
  var isStandard = (0, _react.useMemo)(function () {
    return Object.keys(_enums.MarkerShapesStandard).includes(id);
  }, [id]);
  var isVisible = (0, _react.useMemo)(function () {
    var _data$characteristics;
    return data !== null && data !== void 0 && (_data$characteristics = data.characteristics) !== null && _data$characteristics !== void 0 && _data$characteristics.markerEnabledFlag ? true : false;
  }, [data]);
  var handleMarkerTransform = function handleMarkerTransform(e) {
    /**
     * Konva.Transformer modifies scale of the node
     * but data store tracks position
     * translate scale to position and reset scale
     */
    var marker = e.target;
    var attrs = {};
    switch (marker.className) {
      case "Circle":
        attrs = {
          point: {
            x: marker.x() * marker.scaleX(),
            y: marker.y() * marker.scaleY()
          }
        };
        break;
      case "Line":
        // https://stackoverflow.com/a/57641487 - see SergioP @ Jun 1, 2021 at 16:00
        // https://stackoverflow.com/a/73662484
        var prevPoints = marker.points();
        var nextPoints = [];
        if (marker.scaleX() !== 1 || marker.scaleY() !== 1) {
          // transform
          for (var i = 0; i < prevPoints.length; i += 2) {
            var point = marker.getTransform().point({
              x: prevPoints[i],
              y: prevPoints[i + 1]
            });
            nextPoints.push(point.x, point.y);
          }
        } else {
          // dragging
          var tr = marker.getTransform().decompose();
          var dx = (tr.x || lastTransform.x) - lastTransform.x;
          var dy = (tr.y || lastTransform.y) - lastTransform.y;
          setLastTransform({
            x: tr.x || lastTransform.x,
            y: tr.y || lastTransform.y
          });
          for (var _i = 0; _i < prevPoints.length; _i += 2) {
            var _point = {
              x: prevPoints[_i] + dx,
              y: prevPoints[_i + 1] + dy
            };
            nextPoints.push(_point.x, _point.y);
          }
        }

        // Reset transform
        marker.scaleX(1);
        marker.scaleY(1);
        marker.x(0);
        marker.y(0);
        attrs = {
          start: {
            x: nextPoints[0],
            y: nextPoints[1]
          },
          finish: {
            x: nextPoints[2],
            y: nextPoints[3]
          }
        };
        break;
      case "Rect":
        var newWidth = Math.abs(marker.width() * marker.scaleX());
        var newHeight = Math.abs(marker.height() * marker.scaleY());
        var UL = {
          x: Math.min(marker.x(), marker.x() + newWidth),
          y: Math.min(marker.y(), marker.y() + newHeight)
        };
        attrs = {
          UL: UL,
          LR: {
            x: UL.x + newWidth,
            y: UL.y + newHeight
          }
        };
        break;
      case "Ellipse":
        var newRadiusX = Math.abs(marker.radiusX() * marker.scaleX());
        var newRadiusY = Math.abs(marker.radiusY() * marker.scaleY());
        attrs = {
          UL: {
            x: marker.x() - newRadiusX,
            y: marker.y() - newRadiusY
          },
          LR: {
            x: marker.x() + newRadiusX,
            y: marker.y() + newRadiusY
          }
        };
        break;
      default:
        break;
    }

    // reset transform attributes
    marker.scaleX(1);
    marker.scaleY(1);
    marker.rotation(0);
    onMarkerUpdate(_objectSpread({
      type: marker.className,
      id: marker.name(),
      name: data.characteristics.markerName
    }, attrs));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Group.TransformGroup, {
    id: id,
    disabled: isStandard,
    isSelected: isSelected,
    onMouseDown: onMouseDown,
    onMouseEnter: function onMouseEnter(e) {
      return _onMouseEnter === null || _onMouseEnter === void 0 ? void 0 : _onMouseEnter(e);
    },
    visible: isVisible,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(KonvaMarker, {
      name: id,
      type: type,
      data: data,
      rotation: rotation,
      formatDisplayTemperature: formatDisplayTemperature,
      draggable: !isStandard,
      strokeEnabled: true,
      onDragStart: function onDragStart(e) {
        return setLastTransform(e.target.getTransform().decompose());
      },
      onDragMove: handleMarkerTransform,
      onTransform: handleMarkerTransform
    })
  });
}
function arePropsEqual(prevProps, nextProps) {
  /**
   * Checks if specific properties of the `data` prop in the `Marker`
   * component's props have changed between the previous and next render.
   * Used as an argument to `React.memo` to optimize rendering.
   */
  if (prevProps.id !== nextProps.id || prevProps.isSelected !== nextProps.isSelected || prevProps.rotation !== nextProps.rotation || prevProps.onMarkerUpdate !== nextProps.onMarkerUpdate) {
    // Change detected, return false to trigger rerender
    return false;
  }
  var _prevProps$data = prevProps.data,
    prevMarker = _prevProps$data === void 0 ? {} : _prevProps$data;
  var _nextProps$data = nextProps.data,
    nextMarker = _nextProps$data === void 0 ? {} : _nextProps$data;
  var keysToCheck = ["markerPixelIndexFinish", "markerPixelIndexFinish_OutputImageCoordinates", "markerPixelIndexStart", "markerPixelIndexStart_OutputImageCoordinates", "markerPixelIndexLR", "markerPixelIndexLR_OutputImageCoordinates", "markerPixelIndexUL", "markerPixelIndexUL_OutputImageCoordinates", "markerPixelIndex", "markerPixelIndex_OutputImageCoordinates"];
  for (var _i2 = 0, _keysToCheck = keysToCheck; _i2 < _keysToCheck.length; _i2++) {
    var key = _keysToCheck[_i2];
    if (prevMarker[key] !== nextMarker[key]) {
      // Change detected, return false to trigger rerender
      return false;
    }
  }

  // No changes detected, return true to prevent rerender
  return true;
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(Marker, arePropsEqual);